import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { I18nProvider, loadMultipleTranslations } from "i18n-fe";
import commonTranslations from "./locales/en/common.json";
import announcerTranslations from "./locales/en/announcer.json";

loadMultipleTranslations({
  en: {
    common: commonTranslations,
    announcer: announcerTranslations,
  },
});

// Shared Cognito pool config (same shape as account-fe/manager-fe/scribe-fe).
// Values come from VITE_COGNITO_* (build-time env, see .github/workflows/deploy.yml).
// #1561: no userStore here on purpose: session stays in sessionStorage, not
// localStorage. Full reasoning + measurements in CognitoAuthProvider.jsx
// (packages/common-fe/src/components/CogntioAuthProvider.jsx).
const cognitoAuthConfig = {
  authority: import.meta.env.VITE_COGNITO_AUTHORITY,
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_COGNITO_REDIRECT_URI,
  post_logout_redirect_uri: import.meta.env.VITE_COGNITO_POST_LOGOUT_REDIRECT_URI,
  response_type: "code",
  scope: "openid email profile aws.cognito.signin.user.admin",
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <I18nProvider defaultLanguage="en">
      <App cognitoAuthConfig={cognitoAuthConfig} />
    </I18nProvider>
  </BrowserRouter>
);
